import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/shared/services/app.service';
import { Request } from 'src/app/shared/models/request.model';
import { RequestService } from 'src/app/shared/services/request.service';
import { Category } from 'src/app/shared/models/category.model';
import { CategoryService } from 'src/app/shared/services/category.service';
import {Location} from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Attachement } from 'src/app/shared/models/attachement.model';
@Component({
  selector: 'app-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss']
})
export class ProductDescriptionComponent implements OnInit {
  public selectedProblems: string[] = [];
  public request: Request = new Request();
  private sub: any;
  private querySub: any;
  public serialNumber: string = "";
  public categories: Category[] = [];
  public selectedLanguage: string;
  public type: string = "";
  public disableUploadButton: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private appService: AppService, private requestService: RequestService, private categoryService: CategoryService, private _location: Location, public translate: TranslateService) { }

  ngOnInit(): void {
    this.appService.setProgress("50");
    this.sub = this.activatedRoute.params.subscribe((params) => {
        this.serialNumber = params['serialNumber'];
    });
    this.appService.getLanguage().subscribe(language => {
      this.selectedLanguage = language;
    });
    this.querySub = this.activatedRoute.queryParams.subscribe(queryParams => {
      this.type = queryParams['type'];
    })
    this.getCategories();
  }

  public getCategories() {
    this.categoryService.getAllCategories().subscribe(data => {
      this.categories = data;
      console.log(data);//TODO: delete
    });
  }

  public checkIfProblemIsSelected(problem: string) {
    let isSelected = false;
    this.selectedProblems.forEach(element => {
      if (element == problem) {
        isSelected = true;
      }
    });

    return isSelected;
  }

  public back(){
    this._location.back();
  }

  public selectProblem(problem: string) {
    let isAlreadySelected = false;
    this.selectedProblems.forEach(element => {
      if (problem == element) {
        isAlreadySelected = true;
      }
    });

    if (isAlreadySelected) {
      this.selectedProblems.splice(this.selectedProblems.indexOf(problem), 1);
    } else {
      this.selectedProblems.push(problem);
    }

    console.log(this.selectedProblems);
    
  }

  public onSubmit() {
    
    this.selectedProblems.forEach(problem => {
      this.request.qualification += (problem + ", ");
    });
    this.request.qualification = this.request.qualification.substring(0, this.request.qualification.length -2);

    this.requestService.setRequest(this.request);

    this.router.navigate(["/request/" + this.serialNumber] , { queryParams: {type: this.type}});
  }

  public onFileInput(files: FileList) {
    let alertText;
    let maxfileSize = 2 * 1024 * 1024;
    if (files.length > 3 || (this.request.attachments.length + files.length) > 3) {
      
      if(this.selectedLanguage === "en") alertText = "Please add max. 3 files";
      if(this.selectedLanguage === "fr") alertText = "Veuillez ajouter 3 fichiers au maximum";
      if(this.selectedLanguage === "nl") alertText = "Gelieve max. 3 bestanden toe te voegen";
      window.alert(alertText)
    } else {
      for(let i = 0; i < files.length; i++) {
        if (files[i].size > maxfileSize) {
          if(this.selectedLanguage === "en") alertText = "Please only attach files smaller than 2mb";
          if(this.selectedLanguage === "fr") alertText = "Veuillez ne joindre que des fichiers de moins de 2mb";
          if(this.selectedLanguage === "nl") alertText = "Gelieve enkel bestanden toe te voegen kleiner dan 2mb";
          window.alert(alertText)
        } else if (files[i].type != "image/png" && files[i].type != "image/jpeg" && files[i].type != "image/jpg" && files[i].type != "image/gif") {
          if(this.selectedLanguage === "en") alertText = "Only jpg, png and gif files are allowed";
          if(this.selectedLanguage === "fr") alertText = "Seuls les fichiers jpg, png et gif sont autorisés.";
          if(this.selectedLanguage === "nl") alertText = "Enkel jpg, png en gif bestanden zijn toegelaten";
          window.alert("Enkel jpg, png en gif bestanden zijn toegelaten")
        } else {
          this.getBase64(files[i]);
        }
      }
    }

  }

  public getBase64(file: any) {
    this.disableUploadButton = true;
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        let attachement = new Attachement();
        attachement.path = file.name;
        attachement.file = event.target.result;
        this.request.attachments.push(attachement);
        this.disableUploadButton = false;
      };
      reader.onerror = (event: any) => {
        this.disableUploadButton = false;
      }
  }

  public removeAttachment(index: number) {
    this.request.attachments.splice(index, 1);
  }
}
